import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {detectionApi} from '../../../../http/Api';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import WhiteListComponent from '../../../template/status/whiteList/WhiteListComponent';
import NotificationTamplateBlock from '../../../template/status/notifications/NotificationTamplateBlock';
import NotificationTamplateBlockPlug from '../../../template/status/notifications/NotificationTamplateBlockPlug';
import StatustamplateFaceDetection from '../../../template/status/statusBlock/StatustamplateFaceDetection';
import FlagCustomisationFakeDetection from '../../../template/flagCostomisationTamplate/FlagCustomisationFakeDetection';
import PopUpSubscribeTamplate from '../../../template/popUp/PopUpSubscribeTamplate';
import {useChanges} from '../../../../hooks/useChanges';
import {useAdvanceChanges} from '../../../../hooks/useAdvanceChanges';
import {getDetection, getDetectionAdvanced} from '../../../../store/Detection';

const StatusFakeDetection = () => {
  const {handleSaveChanges, cancelChanges} = useChanges();
  const {handleSaveAdvanceChanges, cancelAdvanceChanges} = useAdvanceChanges();
  const [isPopUoSubscribe, setIsPopUoSubscribe] = useState(false);
  const {detectionGlobalState, detectionAdvancedGlobalState} = useSelector(
    (state) => state.detection,
  );
  const {changesDetected} = useSelector((state) => state.changeDetected);
  const {changesAdvanceDetected} = useSelector((state) => state.changeAdvanceDetected);
  const [isSubscribe, setIsSubscribe] = useState(detectionGlobalState?.data?.premium);

  return (
    <div className="setting_component_wrap">
      <div className="overview_component_content_head">
        <h4>Fake Detection</h4>
        <p>
          Prevent server destruction and malicious activity by monitoring and flagging suspicious
          user behaviour
        </p>
      </div>
      <div className="status_varification_content_wrap" style={{width: '100%'}}>
        <StatustamplateFaceDetection data={detectionGlobalState} />
        <WhiteListComponent data={detectionGlobalState} />
        {!isSubscribe ? (
          <NotificationTamplateBlockPlug setIsPopUpSubscribe={setIsPopUoSubscribe} />
        ) : (
          <NotificationTamplateBlock data={detectionGlobalState?.data} />
        )}
        {isPopUoSubscribe && (
          <PopUpSubscribeTamplate
            setIsSubscribe={setIsSubscribe}
            setIsPopUpSubscribe={setIsPopUoSubscribe}
          />
        )}
        {changesDetected && (
          <ChangeDetectedItem
            cancel={cancelChanges}
            onSave={() => handleSaveChanges(detectionApi.updateDetection, getDetection)}
          />
        )}
      </div>
      <FlagCustomisationFakeDetection
        title={'Advance Settings'}
        text={'In-depth customisation with flexible flag system'}
        data={detectionAdvancedGlobalState?.data}
      />
      {changesAdvanceDetected && (
        <ChangeDetectedItem
          cancel={cancelAdvanceChanges}
          onSave={() =>
            handleSaveAdvanceChanges(detectionApi.updateDetectionAdvanced, getDetectionAdvanced)
          }
        />
      )}
    </div>
  );
};

export default StatusFakeDetection;
